import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SelectionSetIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 16 16"
    >
      <rect x="3" y="3" width="10" height="10" fill={color} />
    </BaseIcon>
  ),
);

SelectionSetIcon.displayName = 'SelectionSetIcon';
